<div mat-dialog-content>
  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
    <mat-tab-group
      mat-align-tabs="center"
      [selectedIndex]="tabs.value"
      (selectedIndexChange)="tabs.setValue($event)"
      class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
    >
      <mat-tab
        label="Create product"
        [disabled]="tabCreate"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      >
        <div
          class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          row
        "
          [formGroup]="formProducts"
          style="margin-top: 17px"
        >
          <div
            class="
            col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            row
          "
          >
            <div
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            >
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Company name</mat-label>
                  <mat-select formControlName="CustomerSelect">
                    <mat-option
                      *ngFor="let datos of Customer"
                      [value]="datos.key"
                      >{{ datos.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-4"
              >
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Item number</mat-label>

                  <input
                    type="text"
                    matInput
                    placeholder="Item number"
                    formControlName="skuItemNumber"
                    maxlength="100"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
              >
                <mat-checkbox class="example-margin" formControlName="checked"
                  >Active</mat-checkbox
                >
              </div>
            </div>
            <div
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            >
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
              >
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Description</mat-label>
                  <textarea
                    matInput
                    placeholder="Description"
                    formControlName="description"
                    maxlength="250"
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                  ></textarea>
                </mat-form-field>
              </div>
              <div
                class="col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6"
                *ngIf="!IsLDT"
              >
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Additional description</mat-label>
                  <textarea
                    matInput
                    placeholder="Additional Description"
                    formControlName="additionalDescription"
                    maxlength="250"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>

            <div
              *ngIf="!IsLDT"
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            >
              <div
                class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
              >
                <div
                  class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  row
                "
                >
                  <h3
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                  >
                    Barcode numbers
                  </h3>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Box barcode</mat-label>

                      <input
                        type="text"
                        matInput
                        placeholder="Box barcode"
                        formControlName="boxBarcode"
                        maxlength="50"
                        class="
                        col-xs-12
                        col-sm-12
                        col-md-12
                        col-lg-12
                        col-xl-12
                        col-xxl-12
                      "
                      />
                    </mat-form-field>
                  </div>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Inner box barcode</mat-label>

                      <input
                        type="text"
                        matInput
                        placeholder="Inner box barcode"
                        formControlName="innerBoxBarcode"
                        maxlength="50"
                        class="
                        col-xs-12
                        col-sm-12
                        col-md-12
                        col-lg-12
                        col-xl-12
                        col-xxl-12
                      "
                      />
                    </mat-form-field>
                  </div>
                  <div
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Product barcode</mat-label>

                      <input
                        type="text"
                        matInput
                        placeholder="Product barcode"
                        formControlName="productBarcode"
                        maxlength="50"
                        class="
                        col-xs-12
                        col-sm-12
                        col-md-12
                        col-lg-12
                        col-xl-12
                        col-xxl-12
                      "
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>

              <div
                class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
              >
                <div
                  class="
                  col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                  row
                "
                >
                  <h3
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                  "
                  >
                    Box dimensions
                  </h3>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Length</mat-label>

                      <input
                        type="number"
                        matInput
                        placeholder="Length"
                        formControlName="length"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Width</mat-label>

                      <input
                        type="number"
                        matInput
                        placeholder="Width"
                        formControlName="width"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Height</mat-label>

                      <input
                        type="number"
                        matInput
                        placeholder="Height"
                        formControlName="Height"
                      />
                    </mat-form-field>
                  </div>
                  <div
                    class="
                    col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                  "
                  >
                    <mat-form-field appearance="fill">
                      <mat-label>Weight</mat-label>

                      <input
                        type="number"
                        matInput
                        placeholder="Weight"
                        formControlName="Weight"
                      />
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="-
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            >
              <h3
                class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              "
              >
                Product quantity details
              </h3>
              <div
                *ngIf="!IsLDT"
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill" class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12">
                  <mat-label>Unit type</mat-label>
                  <mat-select formControlName="selectUnitType">
                    <mat-option
                      *ngFor="let datos of typeUnit"
                      [value]="datos.key"
                      >{{ datos.value }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>StackablePallet</mat-label>
                  <mat-select formControlName="StackablePallet">
                    <mat-option value="0">No stackable </mat-option>
                    <mat-option value="1">Stackable 1 High</mat-option>
                    <mat-option value="2">Stackable 2 High</mat-option>
                    <mat-option value="3">Stackable 3 High</mat-option>
                    <mat-option value="4">Stackable 4 High</mat-option>
                    <mat-option value="5">Stackable 5 High</mat-option>
                    <mat-option value="6">Stackable 6 High</mat-option>
                    <mat-option value="7">Stackable 7 High</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div
                *ngIf="!IsLDT"
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Quantity in master box</mat-label>

                  <input
                    type="number"
                    matInput
                    placeholder="Quantity in master box"
                    formControlName="MasterBox"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="!IsLDT"
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Quantity in inner box</mat-label>

                  <input
                    type="number"
                    matInput
                    placeholder="Quantity in inner box"
                    formControlName="InnerBox"
                  />
                </mat-form-field>
              </div>
              <div
                *ngIf="!IsLDT"
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Product value</mat-label>

                  <input
                    type="number"
                    matInput
                    placeholder="Product value"
                    formControlName="ProductName"
                  />
                </mat-form-field>
              </div>
            </div>
            <div
              *ngIf="!IsLDT"
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
            >
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Pallet quantity</mat-label>

                  <input
                    type="number"
                    matInput
                    placeholder="Pallet quantity"
                    formControlName="PalletQuantity"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Min reorder quantity</mat-label>

                  <input
                    type="number"
                    matInput
                    placeholder="Min reorder quantity"
                    formControlName="ReorderQuantity"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Serial no.</mat-label>

                  <input
                    type="text"
                    matInput
                    placeholder="Serial no."
                    formControlName="SerialNumber"
                  />
                </mat-form-field>
              </div>
              <div
                class="col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3"
              >
                <mat-form-field appearance="fill">
                  <mat-label>Misc field</mat-label>

                  <input
                    type="text"
                    matInput
                    placeholder="Misc field"
                    formControlName="MiscField"
                  />
                </mat-form-field>
              </div>
            </div>

            <div
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
              row
            "
              style="text-align: center"
            >
              <div
                class="
                col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
                row
              "
              >
                <div
                  class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
                ></div>
                <div
                  class="col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-8"
                  style="left: 5vh; margin-bottom: 4vh"
                >
                  <div
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                    row
                  "
                  >
                    <div
                      class="
                      col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                    "
                    >
                      <button
                        mat-raised-button
                        color="danger"
                        style="margin-top: 8px"
                        class="
                        col-xs-12
                        col-sm-12
                        col-md-12
                        col-lg-12
                        col-xl-12
                        col-xxl-12
                      "
                        (click)="OnCancel()"
                      >
                        Cancel
                      </button>
                    </div>
                    <div
                      class="
                      col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6
                    "
                    >
                      <button
                        mat-raised-button
                        color="primary"
                        style="margin-top: 8px"
                        class="
                        col-xs-12
                        col-sm-12
                        col-md-12
                        col-lg-12
                        col-xl-12
                        col-xxl-12
                      "
                        (click)="OnProductsAdd()"
                      >
                        Save product
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  class="col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-2"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </mat-tab>

      <mat-tab
        label="Search products"
        [disabled]="tabSearch"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      >
        <div
          class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          row
        "
          style="margin-top: 17px"
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field appearance="fill">
              <mat-label>Company name</mat-label>
              <mat-select
                [(value)]="selected"
                (selectionChange)="OnSelectSearchProducts($event.value)"
              >
                <mat-option *ngFor="let datos of Customer" [value]="datos.key"
                  >{{ datos.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
            *ngIf="ViewTableProducts"
          >
            <mat-form-field appearance="outline">
              <mat-label>Search</mat-label>
              <input
                matInput
                (keyup)="applyFilter($event)"
                placeholder="Search"
                #input
              />
              <button
                mat-button
                (click)="openDialogLector()"
                matSuffix
                mat-icon-button
                color="primary"
                aria-label="Example icon button with a menu icon"
              >
                <mat-icon>qr_code_scanner</mat-icon>
              </button>
              <mat-hint>Filter table</mat-hint>
            </mat-form-field>
            <div
              class="
              example-container
              mat-elevation-z8
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
            >
              <button
                mat-button
                matSuffix
                mat-icon-button
                color="success"
                (click)="exportAsExcel()"
                aria-label="Example icon button with a menu icon"
                class="col-md-12"
              >
                Excel

                <mat-icon>cloud_download</mat-icon>
              </button>
              <div class="example-table-container" #exportExcel>
                <table
                  mat-table
                  class="example-table"
                  matSort
                  matSortActive="created"
                  matSortDisableClear
                  matSortDirection="desc"
                  [dataSource]="dataSource"
                >
                  <!-- ID Column -->
                  <ng-container matColumnDef="Id" sticky>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Options
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <button
                        mat-raised-button
                        style="width: 87px; height: 43px"
                        (click)="OnEditProducts(row)"
                      >
                        Edit
                      </button>
                      <button
                        mat-raised-button
                        color="danger"
                        style="width: 87px; height: 43px"
                        (click)="OnDelete(row)"
                      >
                        Delete
                      </button>
                    </td>
                  </ng-container>

                  <!-- ItemNumber Column -->
                  <ng-container matColumnDef="ItemNumber">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Item number</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.ItemNumber }}</div>
                    </td>
                  </ng-container>

                  <!-- ItemDescription Column -->
                  <ng-container matColumnDef="ItemDescription">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Item description</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.ItemDescription }}</div>
                    </td>
                  </ng-container>

                  <!-- MasterBarcode Column -->
                  <ng-container matColumnDef="MasterBarcode">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Master barcode</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">{{ row.MasterBarcode }}</div>
                    </td>
                  </ng-container>
                  <!-- PalletAmount Column -->
                  <ng-container matColumnDef="PalletAmount">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      <div class="theadTable">Pallet amount</div>
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <div class="theadTable">
                        {{ row.PalletAmount }}
                      </div>
                    </td>
                  </ng-container>
                  <!-- Active Column -->
                  <ng-container matColumnDef="Active" stickyEnd>
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      Active
                    </th>
                    <td mat-cell *matCellDef="let row">
                      <mat-slide-toggle
                        class="example-margin"
                        [checked]="row.Active"
                        [disabled]="true"
                      >
                      </mat-slide-toggle>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                  ></tr>

                  <!-- Row shown when there is no matching data. -->
                  <tr class="mat-row" *matNoDataRow>
                    <td class="mat-cell" colspan="4">
                      No data matching the filter "{{ input.value }}"
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 25, 100]"></mat-paginator>
          </div>
        </div>
      </mat-tab>
      <mat-tab
        label="Import products"
        class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
      >
        <div
          class="
          col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
          row
        "
        >
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <mat-form-field
              appearance="fill"
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
            >
              <mat-label>Company name</mat-label>
              <mat-select [(value)]="valorCustomerMasivo">
                <mat-option *ngFor="let datos of Customer" [value]="datos.key"
                  >{{ datos.value }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
          <div
            class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
          >
            <div
              class="
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
            >
              <a
                href="..//..//..//assets/example.xlsx"
                target="_blank"
                rel="noopener noreferrer"
                >Download excel format</a
              >
            </div>
            <div
              class="
              center
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
              style="margin-top: 6vh"
            >
              <ngx-file-drop
                dropZoneLabel="Drop files here"
                (onFileDrop)="dropped2($event)"
                (onFileOver)="fileOver2($event)"
                (onFileLeave)="fileLeave2($event)"
              >
                <ng-template
                  ngx-file-drop-content-tmp
                  let-openFileSelector="openFileSelector"
                >
                  <div
                    class="
                    col-xs-12
                    col-sm-12
                    col-md-12
                    col-lg-12
                    col-xl-12
                    col-xxl-12
                    row
                  "
                  >
                    <button
                      type="button"
                      (click)="openFileSelector()"
                      mat-raised-button
                      color="primary"
                      class="
                      col-xs-12
                      col-sm-12
                      col-md-12
                      col-lg-12
                      col-xl-12
                      col-xxl-12
                    "
                    >
                      Browse Files
                    </button>

                    <p
                      style="text-align: center; top: 2vh"
                      class="
                      col-xs-12
                      col-sm-12
                      col-md-12
                      col-lg-12
                      col-xl-12
                      col-xxl-12
                    "
                    >
                      Upload Document
                    </p>
                  </div>
                </ng-template>
              </ngx-file-drop>
            </div>
            <div
              class="
              upload-table
              col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12
            "
              style="margin-top: 6vh"
            >
              <table class="table table-dark table-striped">
                <thead>
                  <tr>
                    <th>Row</th>
                    <th>item number</th>
                    <th>Result</th>
                  </tr>
                </thead>
                <tbody class="upload-name-style">
                  <tr
                    *ngFor="let item of arrayMensajesMasivoExcel; let i = index"
                  >
                    <td>
                      <strong>{{ item.celda }}</strong>
                    </td>
                    <td>
                      <strong>{{ item.itemname }}</strong>
                    </td>
                    <td>
                      <strong>{{ item.mensajes }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Upload file" *ngIf="false" [disabled]="tabUpdate">
        <div
          class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
        >
          <div class="center">
            <ngx-file-drop
              dropZoneLabel="Drop files here"
              (onFileDrop)="dropped($event)"
              (onFileOver)="fileOver($event)"
              (onFileLeave)="fileLeave($event)"
            >
              <ng-template
                ngx-file-drop-content-tmp
                let-openFileSelector="openFileSelector"
              >
                Optional custom content that replaces the the entire default
                content.
                <button type="button" (click)="openFileSelector()">
                  Browse Files
                </button>
              </ng-template>
            </ngx-file-drop>
            <div class="upload-table">
              <table class="table">
                <thead>
                  <tr>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody class="upload-name-style">
                  <tr *ngFor="let item of files; let i = index">
                    <td>
                      <strong>{{ item.relativePath }}</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
<div mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    [mat-dialog-close]="returns"
    id="cancelar"
    class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12"
  >
    Return receiving
  </button>
</div>
